'use client';

import { useEffect } from 'react';

function isChunkError(error: Error & { digest?: string }): boolean {
  const msg = `${error.name} ${error.message}`;
  return (
    /ChunkLoadError/i.test(msg) ||
    /Loading chunk [\w-]+ failed/i.test(msg) ||
    /Loading CSS chunk/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg)
  );
}

const RELOAD_FLAG = 'shot:chunk-reload-at';
const RELOAD_COOLDOWN_MS = 10_000;

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (!isChunkError(error)) return;
    try {
      const last = Number(sessionStorage.getItem(RELOAD_FLAG) ?? 0);
      if (Date.now() - last < RELOAD_COOLDOWN_MS) return;
      sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
    } catch {
    }
    window.location.reload();
  }, [error]);

  return (
    <html lang="ru">
      <body />
    </html>
  );
}
